(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment historie list
    module.directive('agendaAppointmentHistorieList', [function () {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-historie-list.template.html',
            controller: 'AgendaAppointmentHistorieListController',
            controllerAs: 'vm',
            scope: {
                patientId: '='
            },
            bindToController: true,
            replace: true
        };
        return directive;       
    }]);

})();